// extracted by mini-css-extract-plugin
module.exports = {"btnBackground":"Home_btnBackground__1xyD4","btnMargin":"Home_btnMargin__1jBw4","icons":"Home_icons__MDnvj"};